const lipstickConfig = {
  id: 'lipstick',
  label: 'Lipstick',
  icon: 'lipstick',
  colors: [
    // Fair → Light soft nudes / roses
    { name: 'Sheer Nude', hex: '#E8B89A' },
    { name: 'Soft Pink Nude', hex: '#F2C4C4' },
    { name: 'Baby Rose', hex: '#E8A8B0' },
    { name: 'Dusty Rose', hex: '#C78585' },
    { name: 'Rose Petal', hex: '#FF69B4' },
    { name: 'Coral Bliss', hex: '#FF6B6B' },
    { name: 'Soft Mauve', hex: '#C9A0A5' },
    // Medium classics
    { name: 'Hot Pink', hex: '#BF124D' },
    { name: 'Fuchsia', hex: '#CC0066' },
    { name: 'Classic Red', hex: '#FF0000' },
    { name: 'Brick Red', hex: '#BF1A1A' },
    { name: 'Terra Cotta', hex: '#C55A3A' },
    { name: 'Burnt Orange', hex: '#FF4D00' },
    { name: 'Nude Caramel', hex: '#BC8A5F' },
    { name: 'Spice Nude', hex: '#A66B5A' },
    // Medium-Deep → Very Deep berries / browns
    { name: 'Berry Rose', hex: '#76153C' },
    { name: 'Berry Stain', hex: '#8B2252' },
    { name: 'Dark Cherry', hex: '#9B1B30' },
    { name: 'Cabernet Wine', hex: '#722F37' },
    { name: 'Deep Burgundy', hex: '#5A0E24' },
    { name: 'Deep Plum', hex: '#7B2D8B' },
    { name: 'Brick Berry', hex: '#8B3A3A' },
    { name: 'Cocoa Rose', hex: '#6E3038' },
    { name: 'Chocolate Mocha', hex: '#4E2C2C' },
    { name: 'Espresso Berry', hex: '#3D1A22' },
  ],
  supportsDualColor: true,
  finishTypes: [
    { id: 'matte', name: 'Matte' },
    { id: 'satin', name: 'Satin' },
    { id: 'glossy', name: 'Glossy' },
    { id: 'metallic', name: 'Metallic' },
  ],
  intensityDefault: 50,
  intensityMin: 0,
  intensityMax: 100,
};

export default lipstickConfig;
